import React, { FC } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

type TSubRoute = {
  label: string;
  route: string;
};

type TSubMenuProps = {
  routes?: TSubRoute[];
};

const SubMenu: FC<TSubMenuProps> = ({ routes }) => {
  if (!routes || !routes.length) {
    return null;
  }
  return (
    <SList>
      {routes.map(({ label, route }) => (
        <SListItem key={route}>
          <SStyledLink to={`/${route}`}>{label}</SStyledLink>
        </SListItem>
      ))}
    </SList>
  );
};

export default SubMenu;

const SList = styled.ul`
  list-style: none;
  width: 200px;
  margin: 16px auto 8px;
  padding: 8px 0 8px 36px;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const SListItem = styled.li`
  padding: 0 12px;
  &:not(:last-of-type) {
    margin-bottom: 24px;
  }
`;

const SStyledLink = styled(NavLink)`
  font-family: 'aesthet-nova';
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  color: #0d0d0d;

  &.active {
    border-bottom: 1px solid #fcc425;
    padding-bottom: 4px;
  }
`;
